/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentInfosOrderCancellationCharge: "shipment-infos-order-cancellation-charge",
  shipmentInfosLock: "shipment-infos-lock",
  shipmentInfosUnlock: "shipment-infos-unlock",
  shipmentInfosAccept: "shipment-infos-accept",
  shipmentInfosAssign: "shipment-infos-assign",
  shipmentInfosKeepOrder: "shipment-infos-keep-order",
  shipmentInfosConfirmCancellation: "shipment-infos-confirm-cancellation",
  shipmentInfosReasonOptions: "shipment-infos-reason-options",
  shipmentInfosReasonOption: "shipment-infos-reason-option",
  shipmentInfosReasonField: "shipment-infos-reason-field",
} as const;
